// extracted by css-extract-rspack-plugin
export default {"status_card":"nPhcxhFs1ssINSZB","status_select_wrapper":"f9qUqdvyOYQbpW2Y","readonly":"HfjdKN1HRckjeDZb"};